import React, { useMemo, useState } from 'react';
import { Modal } from '../../components/ui';
import { fullName } from '../../utils/helpers';

// "Put this guest into a family" — a guest standing on their own joins an
// EXISTING family (the server moves them, never copies). Creating a family
// with this person as the head is the other button, on the card.
export default function JoinFamilyMobile({ guest, families, onClose, onPick }) {
  const [q, setQ] = useState('');
  const shown = useMemo(() => {
    const needle = q.trim().toLowerCase();
    return needle ? families.filter(f => f.label.toLowerCase().includes(needle)) : families;
  }, [families, q]);

  return (
    <Modal fullScreen title={`Add ${fullName(guest)} to…`} onClose={onClose}
      footer={<button className="btn light" style={{ flex: 1, padding: 12 }} onClick={onClose}>Cancel</button>}>
      {families.length === 0 ? (
        <div className="muted" style={{ fontSize: 13 }}>
          No families yet. Use “Create Family” on a guest to make this person the head of one.
        </div>
      ) : (
        <>
          <input placeholder="Search families…" value={q} onChange={e => setQ(e.target.value)}
            style={{ width: '100%', padding: 12, fontSize: 16, border: '1px solid var(--line)', borderRadius: 10, marginBottom: 10 }} />
          <div className="num-choice">
            {shown.map(f => (
              <button key={f.familyId} type="button" className="num-choice-row big" onClick={() => onPick(f)}>
                <strong>{f.label}</strong>
                <span className="muted">{f.size} {f.size === 1 ? 'person' : 'people'}</span>
              </button>
            ))}
            {shown.length === 0 && <div className="muted" style={{ fontSize: 13 }}>No family matches “{q}”.</div>}
          </div>
        </>
      )}
    </Modal>
  );
}
